export default __webpack_public_path__ + "static/media/4.6af9331a.png";